import { PACKAGE_CLASSNAME, HERO_SECTION_SELECTOR, LEGACY_HERO_SECTION_SELECTOR, HERO_SECTION_ID } from './constants';

/**
 * Calculates the offset for the hero section on logo maker landing pages.
 * @return {Number}
 */
const getHeroOffset = () => {
    const element =
        document.querySelector(HERO_SECTION_SELECTOR) ||
        document.querySelector(LEGACY_HERO_SECTION_SELECTOR) ||
        document.getElementById(HERO_SECTION_ID);

    if (!element) {
        return;
    }

    const header = document.querySelector(`.${PACKAGE_CLASSNAME}`);

    const { height: headerHeight } = header.getBoundingClientRect();
    const { height: elementHeight } = element.getBoundingClientRect();

    return elementHeight - headerHeight;
};

export default getHeroOffset;
